import canUse from './canUse'

const SetUser = (user) =>
    canUse() && localStorage.setItem('USER', JSON.stringify(user))

export default SetUser
